import { FC } from 'react';
import dayjs from 'dayjs';
import { TableBody as Body } from '@mui/material';

import { HeaderProperties } from '../../../../shared/uiComponents/Table/tableProperties';
import { BadgeTypes, SoapNoteStatusTypes } from '../../../../shared/uiComponents/StatusBadge';
import { Badge } from '../../../../shared/uiComponents';
import { CustomTableRow, RowTableCell } from '../../../../shared/uiComponents/Table/tableHelpers';
import Actions from '../../Actions';

import { SoapNotesFullProperties } from '../../../../redux/API/ClientAPIHelpers/soapNoteProperties';

export interface RowRendererProperties {
	data: SoapNotesFullProperties[];
}

export const Headers: HeaderProperties[] = [
	{ id: '8', name: 'Provider Name', orderBy: 'user.fullName' },
	{ id: '1', name: 'Client Name', orderBy: 'client.fullName' },
	{ id: '2', name: 'Type', orderBy: 'sessionType.name' },
	{ id: '3', name: 'Session Date', orderBy: 'date' },
	{ id: '4', name: 'SOAP Note Created', orderBy: 'createdAt' },
	{ id: '5', name: 'Created by', orderBy: 'createdBy.fullName' },
	{ id: '6', name: 'Status' },
	{ id: '7', name: 'Actions', width: '120px' },
];

export const TableBody: FC<RowRendererProperties> = ({ data }) => (
	<Body>
		{data.map((row, index) => (
			<CustomTableRow key={index}>
				<RowTableCell>{row.user.fullName}</RowTableCell>
				<RowTableCell>{row.client.fullName}</RowTableCell>
				<RowTableCell>{row.sessionType.name}</RowTableCell>
				<RowTableCell>{dayjs(row.date).format('MM/DD/YYYY')}</RowTableCell>
				<RowTableCell>{dayjs(row.createdAt).format('MM/DD/YYYY')}</RowTableCell>
				<RowTableCell>{row.createdBy.fullName}</RowTableCell>
				<RowTableCell>
					<Badge label={row.status.name} sizeType="sm" type={SoapNoteStatusTypes[row.status.status] as BadgeTypes} />
				</RowTableCell>
				<RowTableCell>
					<Actions data={row} />
				</RowTableCell>
			</CustomTableRow>
		))}
	</Body>
);
